import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Form, Container, Spinner } from 'react-bootstrap';
import {
    uploadImages
} from '../../../common/Utilities'
import {
    getAppVersion,
    resetAppVersion,
    upsertAppVersion,
    handleInputChange
} from '../../../store/actions/appversions/appVersionsActions'
import { PUBLISHED, DRAFT } from '../../../store/actions/posts/postsActions';
import ProgressingButton from '../../../common/ProgressingButton'
import { setIsSaving } from '../../../store/actions/commonActions'

import PageTitle from '../../../common/PageTitle';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { format } from 'date-fns';

class AppVersionForm extends Component {

    constructor(props) {
        super(props);
        this.pathname = this.props.location.pathname;
        this.title = 'Add Version';
        this.isReady = false;
    }



    componentWillUnmount() {
        this.props.resetAppVersion();
    }

    render() {

        const appversion = this.props.appversions.appversion;

        let image;
        if (appversion.image) {
            image = <img src={appversion.image} alt={appversion.label} />
        }
        if (this.props.common.isSaving) {
            image = <Spinner animation="border" size="sm" />
        }

        if (!this.isReady && (appversion.id || this.pathname !== '/splash-screens/edit')) {
            this.isReady = true;
        }

        return this.isReady ? (
            <div>
                <Container className="waa-container">
                    <PageTitle pageName={this.title} />
                    <hr />
                    <Col>
                        <Form className="waa-form">
                            <Form.Group controlId="formScreenLabel">
                                <Form.Label>Application Version</Form.Label>
                                <Form.Control
                                    type="text"
                                    pattern="^[0-9][0-9.]*$" // Use a pattern to allow a number followed by multiple decimals
                                    value={appversion.version_update}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        const updatedValue = input.replace(/[^0-9.]/g, ''); // Remove any non-numeric and non-decimal characters
                                        this.props.handleInputChange(null, {
                                            version_update: updatedValue,
                                        });
                                    }}
                                />
                            </Form.Group>

                            {/* <Form.Group controlId="formScreenLabel">
                                <Form.Label>Publisher</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={appversion.publisher}
                                    onChange={(e) => {
                                        this.props.handleInputChange(null, {
                                            publisher: e.target.value
                                        });
                                    }}
                                />
                            </Form.Group> */}
                            <Form.Group controlId="formScreenLabel">
                                <Form.Label>Published Date</Form.Label>
                                <DatePicker
                                    selected={appversion.published_date}
                                    utcOffset={0}
                                    dateFormat="MM-dd-y"
                                    onChange={(date) => {
                                        if (date) {
                                          date.setHours((-1 * date.getTimezoneOffset()) / 60);
                                        }
                                        this.props.handleInputChange(null, {
                                          published_date: date
                                        }); 
                                      }}
                                      
                                />
                            </Form.Group>
                            <ProgressingButton
                                className="save-button"
                                type="submit"
                                variant="primary"
                                onClick={this.props.upsertAppVersion}
                                buttonValue="Save" />
                        </Form>
                    </Col>
                </Container>
            </div>
        ) : <Spinner animation="border" size="sm" />
    }
}

const mapStateToProps = (state) => ({
    users: state.users,
    appversions: state.appversions,
    common: state.common
})

const mapDispatchToProps = (dispatch) => {
    return {
        getAppVersion: (...args) => dispatch(getAppVersion(...args)),
        resetAppVersion: (...args) => dispatch(resetAppVersion(...args)),
        upsertAppVersion: (...args) => dispatch(upsertAppVersion(...args)),
        handleInputChange: (...args) => dispatch(handleInputChange(...args)),
        setIsSaving: (...args) => dispatch(setIsSaving(...args)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppVersionForm))
